<div class="settingPage scrollPage templatePage">


    <div class="alert alert-warning" role="alert" *ngIf="labelSynchroErrors.length > 0">
        <div *ngFor="let item of labelSynchroErrors">
            <fa-icon icon="exclamation-triangle" size="1x" [fixedWidth]="true" style="color: red;"></fa-icon>
            {{ item }}
        </div>
    </div>

    <div class="pl-2 pr-2  mt-2">
        <div class="row ml-0 mr-0">
            <div class="col-sm-12 bg-kubota p-2">
                <span class="text-uppercase font-weight-bold">{{ 'settingPage.syncDataSetting' | translate  }}</span>
            </div>
        </div>

        <div class="row bg-light ml-0 mr-0 mb-2 pt-3 pb-3">
            <div class="col-sm-3">
                <label>{{ 'settingPage.syncMode' | translate }}</label>
            </div>
            <div class="col-sm-9">
                <button type="button" class="btn btn-block"
                        [ngClass]="{'btn-warning': !isAutoSync, 'btn-info': isAutoSync}"
                        (click)="startOrStopAutoSync()">
                        <span *ngIf="isAutoSync">
                            <fa-icon icon="sync" size="1x" [fixedWidth]="true"></fa-icon>
                            {{ 'settingPage.syncAuto' | translate }}
                        </span>
                    <span *ngIf="!isAutoSync">
                        <fa-layers [fixedWidth]="true">
                            <fa-icon icon="sync"></fa-icon>
                            <fa-icon icon="ban" style="color: red;" transform="grow-16"></fa-icon>
                        </fa-layers>
                        &nbsp;
                        {{ 'settingPage.syncManual' | translate }}
                        </span>
                </button>

            </div>
        </div>
        <div class="row bg-light ml-0 mr-0 mb-2 pt-3 pb-3">
            <div class="col-sm-3">
                <label>{{ 'settingPage.sync' | translate }}</label>
            </div>
            <div class="col-sm-9">
                <button type="button" class="btn btn-success btn-block" (click)="startSynchro()" *ngIf="!isSyncing">
                    <fa-icon icon="play-circle" size="1x" [fixedWidth]="true"></fa-icon>
                    {{ 'settingPage.startSynchro' | translate }}
                </button>
                <button type="button" class="btn btn-danger btn-block" (click)="stopSynchro()" *ngIf="isSyncing">
                    <fa-icon icon="stop-circle" size="1x" [fixedWidth]="true"></fa-icon>
                    {{ 'settingPage.stopSynchro' | translate }}
                </button>
            </div>
        </div>

        <div class="row ml-0 mr-0 mb-2">
            <div class="col-sm-12 pl-0 pr-0" *ngIf="showItemsSize">
                {{ 'settingPage.progressSize' | translate }}
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                         role="progressbar"
                         [style.width.%]="itemsSizePercentage">
                        {{ itemsSizeDone?.toLocaleString() }} / {{ itemsSizeTotal?.toLocaleString() }}
                    </div>
                </div>
            </div>
            <div class="col-sm-12 pl-0 pr-0" *ngIf="showItemsNumber">
                {{ 'settingPage.progressNumber' | translate }}
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-secondary"
                         role="progressbar"
                         [style.width.%]="itemsNumberPercentage">
                        {{ itemsNumberDone?.toLocaleString() }} / {{ itemsNumberTotal?.toLocaleString() }}
                    </div>
                </div>
            </div>
            <div class="col-sm-12  pl-0 pr-0" *ngIf="showCurrentItemSize">
                {{ 'settingPage.progressCurrentSize' | translate }}
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                         role="progressbar"
                         [style.width.%]="currentItemSizePercentage">
                        {{ currentItemSizeDone?.toLocaleString() }} / {{ currentItemSizeTotal?.toLocaleString() }}
                    </div>
                </div>
            </div>
        </div>

        <div class="row ml-0 mr-0">
            <div class="col-sm-12 bg-kubota p-2">
                <span class="text-uppercase font-weight-bold">{{ 'settingPage.defaultParameters' | translate  }}</span>
            </div>
        </div>


        <div class="row bg-light ml-0 mr-0 mb-2 pt-3 pb-3" *ngIf="userPreferences != null">
            <div class="col-sm-3">
                <label>{{ 'settingPage.ponderationUtilisation1' | translate }}</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control"
                       name="inputPonderationUtilisation1"
                       [(ngModel)]="userPreferences.ponderationUtilisation1"
                       placeholder="{{ 'settingPage.ponderationUtilisation1' | translate }}"
                       id="inputPonderationUtilisation1"/>

            </div>
            <div class="col-sm-3">
                <label>{{ 'settingPage.ponderationUtilisation2' | translate }}</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control"
                       name="inputPonderationUtilisation2"
                       [(ngModel)]="userPreferences.ponderationUtilisation2"
                       placeholder="{{ 'settingPage.ponderationUtilisation2' | translate }}"
                       id="inputPonderationUtilisation2"/>
            </div>
            <div class="col-sm-3">
                <label>{{ 'settingPage.lang' | translate }}</label>
            </div>
            <div class="col-sm-9">
                <select class="form-control "
                        [(ngModel)]="userPreferences.lang"
                        name="inputLang"
                        id="inputLang">
                    <option [ngValue]="null" selected>{{'settingPage.defaultLang' | translate}}</option>
                    <option [ngValue]="'fr'" >{{'settingPage.langFR' | translate}}</option>
                    <option [ngValue]="'en'" >{{'settingPage.langEN' | translate}}</option>
                    <option [ngValue]="'de'" >{{'settingPage.langDE' | translate}}</option>
                </select>
            </div>
        </div>
        <div class="row bg-light ml-0 mr-0 mb-2 pt-3 pb-3">
            <div class="col-sm-3">
            </div>
            <div class="col-sm-9">
                <button type="button" class="btn btn-lemken btn-block" (click)="saveSetting()">
                    <fa-icon icon="save" size="1x" [fixedWidth]="true"></fa-icon>
                    {{ 'settingPage.saveSetting' | translate }}
                </button>
            </div>
        </div>


    </div>


</div>
